import { render, staticRenderFns } from "./openID.vue?vue&type=template&id=2313b3a5&scoped=true"
import script from "./openID.vue?vue&type=script&lang=js"
export * from "./openID.vue?vue&type=script&lang=js"
import style0 from "./openID.vue?vue&type=style&index=0&id=2313b3a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313b3a5",
  null
  
)

export default component.exports